module.exports = __webpack_public_path__ + "img/loader_animation_loop.gif";